import { bonzai, type InferBonzai } from "bonzai"
import * as customApi from "../customApi"

export type Custom = InferBonzai<typeof custom>
export const custom = bonzai(customApi)
